import { publicConfig } from '@public-config';

const EmailHelpers = {
    getDomain: (email: string) => {
        return email.split('@').pop()?.trim().toLowerCase();
    },

    imageUrl: (file?: { prefix?: string | null; filename?: string | null; url?: string | null } | null) => {
        if (!file?.url) {
            return undefined;
        }

        if (!publicConfig.imageKitPublicKey || !file.prefix || !file.filename) {
            return file.url;
        }

        return `${publicConfig.imageKitPublicKey}/tr:w-96,h-96,cm-pad_resize,f-png/${file.prefix}/${file.filename}`;
    },

    generateTrackedUrl: (url: string, source: string = '') => {
        return `${publicConfig.urls.frontend}/dispatcher?url=${encodeURIComponent(url)}&source=${encodeURIComponent(source)}`;
    },
};

export { EmailHelpers };
